import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";

export default function CategoryQuickEntry() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            按主题浏览
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            三大内容分类，快速找到你感兴趣的 Vlog
          </p>
        </div>
        <Link
          to="/search"
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          查看全部视频 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => {
          const count = videos.filter((v) => v.category === c.id).length;
          return (
            <Link
              key={c.id}
              to={`/category/${c.id}`}
              className="group relative flex animate-fadeUp flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={c.icon} />
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">
                {c.description}
              </p>
              <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="text-xs font-medium text-foreground-500">{count} 个视频</span>
                <span className="flex items-center gap-1 text-xs font-medium text-accent-600">
                  {c.accentLabel} <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}